import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  navigationMemoryFeatureKey,
  INavigationMemoryState,
} from './types';

const navigationMemoryFeatureState =
  createFeatureSelector<INavigationMemoryState>(navigationMemoryFeatureKey);

export const navigationMemorySelectors = {
  getMemory: createSelector(
    navigationMemoryFeatureState,
    (state: INavigationMemoryState) => state,
  ),
};
